import { Pipe, PipeTransform } from '@angular/core';
/*
 * Usage:
 *   obj: number | timelineCount
*/
@Pipe({name: 'timelineCount'})
export class TimelineCountPipe implements PipeTransform {
  transform(timelineCount: number): string {
      const hours = Math.floor(timelineCount / 2);
      const min = timelineCount % 2;
      let str = ''
      if (hours) str += `${hours} hour`
      if (hours > 1) str += 's '
      else str += ' ' 
      if (min) str += `${min * 30} minutes`
    return str;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/timeline-count.pipe.ts